import { Link } from 'react-router';
import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from 'url:../../../static/logoerraysy.png';
import './Header.scss';

export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className='header'>
      
      <div className='header_logo'>
        <img 
          src={logo} 
          alt="logo_er-raysy_web_education - retour à l'accueil"
        />
        <p className='header__title'>Nouhayla Er-Raysy Web </p>
      </div>

      {/* BURGER */}
      <div 
        className="burger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav className={`header__navigation ${menuOpen ? "active" : ""}`}>
        
        <Link to='/' onClick={closeMenu}>Accueil</Link>

        <div className="dropdown">
          <span>Services ▾</span>
          <div className="dropdown_menu">
            <Link to="/web" onClick={closeMenu}>Création de site internet</Link>
            <Link to="/optimisation" onClick={closeMenu}>Optimisation & Suivi</Link>
          </div>
        </div>

        <Link to='/about' onClick={closeMenu}>À propos</Link>
        <Link to='/contact' onClick={closeMenu}>Contact</Link>

      </nav>
    </header>
  );
}